<mat-form-field #formFieldContainer floatLabel="always" appearance="none" class="import-file-class">
  <mat-label
    #labelContainer (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">{{componentDefinition?.label}}</mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <input matInput placeholder="{{ componentDefinition?.label }}"
         [id]="elementName" [name]="componentDefinition?.name"
         [readonly]="disabled"
         (ngModelChange)="valueChanged($event)"
         [(ngModel)]="document[fieldName]" [hidden]="true">

  <div class="sc-import-file-wrap">
    <div class="uploadbox">
      <!-- drop files here-->
      <div class="selectFileDropContainer"
           ngfDrop
           [(validDrag)]="baseDropValid"
           (fileOver)="hasBaseDropZoneOver=$event"
           [(files)]="files"
           [accept]="accept"
           [maxSize]="maxSize"
           [(dragFiles)]="dragFiles"
           [(lastInvalids)]="lastInvalids"
           title="Drop file here.(Accepts [{{accept}}] files only)"
           [class.invalid-drag]="baseDropValid===false"
           [class.valid-drag]="baseDropValid"
           (filesChange)="onFileSelect(files)"
           [fileDropDisabled]="fileDropDisabled">

          <div class="drop-files-label">
            <mat-icon aria-hidden="false" aria-label="Drop files here" class="mat-icon-upload">backup</mat-icon>
            <span>Drop Files here</span>
            <span>or</span>

            <button type="button" mat-raised-button
                    ngfSelect
                    [accept]="accept"
                    [maxSize]="maxSize"
                    [(files)]="files"
                    class="choose-files-btn"
                    title="Select file (Accepts {{accept}} files only)"
                    [(lastInvalids)]="lastInvalids"
                    (filesChange)="onFileSelect(files)"
                    [disabled]="disabled"
                    color="primary">
              <mat-icon>search</mat-icon>
              <span>Choose Files</span>
            </button>
          </div>
          <div class="drop-files-label-2">
            <button type="button" mat-stroked-button color="primary" title="Save"
                    (click)="funcCallSaveImports()"
                    [disabled]="disabled"
                    [hidden]="disableSaving">
              <mat-icon>save</mat-icon>
              <span [ngClass]="{'f-hide-gt-xs' : !componentDefinition?.fullWidth}">Save</span>
            </button>

            <button type="button" mat-stroked-button color="primary" (click)="resetImport()" [disabled]="disabled"
                    title="Clear">
              <mat-icon>delete_forever</mat-icon>
              <span [ngClass]="{'f-hide-gt-xs' : !componentDefinition?.fullWidth}">Clear</span>
            </button>
          </div>
      </div>
    </div>
  </div>

  <div class="sc-import-file-controls">

    <div
      class="ft-badge-wrap f-flex f-flex-row f-flex-align-items-center f-flex-align-content-center f-flex-justify-space-around"
      *ngIf="componentDefinition.hideStatusCounts !== true">

      <div class="sc-uploadinfos f-flex f-flex-align-items-center" [ngClass]="{
        'f-flex-column': !componentDefinition.fullWidth, 'f-flex-row-reverse': componentDefinition.fullWidth
      }">
        <span class="numberCircle records" matTooltip="Records Read" matTooltipPosition="above">
          <span>{{recordsRead}}</span>
        </span>
        <p>Records Read</p>
      </div>

      <div class="sc-uploadinfos f-flex f-flex-align-items-center" [ngClass]="{
          'f-flex-column': !componentDefinition.fullWidth, 'f-flex-row-reverse': componentDefinition.fullWidth
      }">
        <span class="numberCircle doc-created" matTooltip="Documents Created" matTooltipPosition="above">
          <span>{{documentCreated}}</span>
        </span>
        <p>Documents Created</p>
      </div>

      <div class="sc-uploadinfos f-flex f-flex-align-items-center" [ngClass]="{
        'f-flex-column': !componentDefinition.fullWidth, 'f-flex-row-reverse': componentDefinition.fullWidth
      }">
        <span class="numberCircle error" matTooltip="Errors" matTooltipPosition="above">
          <span>{{errors}}</span>
        </span>
        <p>Errors</p>
      </div>
    </div>
  </div>

  <div class="sc-import-file-table" *ngIf="!isHasTargetTableComponent">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="documentId">
        <th mat-header-cell [hidden]="true" *matHeaderCellDef>DocumentId</th>
        <td mat-cell [hidden]="true" *matCellDef="let element"><a
          href="/form/{{element.documentId}}">{{element.documentId}} </a></td>
      </ng-container>

      <ng-container *ngFor="let labelVal of labelsForNoTargetTable; let i = index" matColumnDef="colData{{i}}">
        <th mat-header-cell *matHeaderCellDef> {{labelVal}} </th>
        <td mat-cell *matCellDef="let element">
          <a *ngIf="!(i>0)" href="/form/{{element.documentId}}">{{element['colData' + (i)]}} </a>
          <ng-container *ngIf="i>0">{{element['colData' + (i)]}}</ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
    <mat-paginator #importFilePaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </div>


</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
